import {
  getColorArray,
} from '../tools/services/colors'

import {
  buildStyleFromLiteral,
} from '../tools/services/styles-literal'

export default function ({ branches = 5, fillColor = [255, 255, 255, 0.4], borderColor = [51, 153, 204, 1], borderWidth = 1, width = 10 } = {}) {
  return buildStyleFromLiteral({
    shape: {
      radius: width,
      fill: {
        color: getColorArray(fillColor),
      },
      stroke: {
        color: getColorArray(borderColor),
        width: borderWidth,
      },
      points: branches,
      radius2: width / 2,
      angle: 0,
    },
  })
}
